import React, { useEffect, useState, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Button, Logo } from 'components'
import { Link, useNavigate } from 'react-router-dom'
import styles from './index.module.css'
import {
    certFromUrlState,
    detailResultDataState,
    reqCdState,
    certTypeState,
    certFromState,
    transmitRequestSelector,
    selectedOrgsState,
} from './states'
import { consentListState, detailLayerState, listLayerState } from 'views/mydata/manage/states'
import { useRecoilValue, useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil'
import Lib from 'library'
import { NoData } from 'components'
import useCommonIndustry from 'hooks/useCommonIndustry'

const DataResult = () => {

    const App = useApp()
    const navigate = useNavigate()

    const [detailResultData, setDetailResultData] = useRecoilState(detailResultDataState)
    const certType = useRecoilValue(certTypeState)
    const resetCertType = useResetRecoilState(certTypeState)
    const reqCd = useRecoilValue(reqCdState)
    const certFrom = useRecoilValue(certFromState)
    const resetCertFrom = useResetRecoilState(certFromState)
    const resetReqCd = useResetRecoilState(reqCdState)
    const resetShowDetailLayer = useResetRecoilState(detailLayerState)
    const resetShowListLayer = useResetRecoilState(listLayerState)
    const resetTransmitRequest = useResetRecoilState(transmitRequestSelector)

    const [certFromUrl, setCertFromUrl] = useRecoilState(certFromUrlState);

    const [data, setData] = useState()
    const [count, setCount] = useState()
    const [successCount, setSuccessCount] = useState()
    const [failCount, setFailCount] = useState()
    const industries = useCommonIndustry()
    const isRetry = useRef(false)

    const retry = () => {
        isRetry.current = true
        navigate("/data/transmitRequest")
    }

    // 마이데이터 연동 결과에 따른 선택한 기관 목록 초기화
    const initSelectedTarget = () => {
        console.log("mydata result ========>", detailResultData);
        // [{"insttCd":"A1AAER0000","insttNm":"주식회사 신한은행","indstCd":"bank","targetInfoList":[{"scope":null,"asset_list":[{"assetNm":"Tops직장>인플랜 저축예금","assetTpNm":"자유입출식","asset":"110235683745","sucesYn":"Y","errDesc":null,"seqno":""},{"assetNm":"외화 체인지업 예금"...

        // 마이데이터 연동을 담고 있는 데이터는 무엇??
        // console.log(consentList); // 기본값인 undefined 가 나옴
        // console.log(selectedOrgsState); // 기본값인  {"key":"selectedOrgsState"} 가 나옴

        // if (data && Array.isArray(data) && data.length > 0) {
        //     const filedRcveRslt = data.reduce((pre, rcveRslt) => {
        //         return {
        //             [rcveRslt.insttCd]: (rcveRslt.sucesYn === "N")
        //         }
        //     }, {})
        //
        //     console.log("filedRcveRslt", filedRcveRslt);
        //     alert(JSON.stringify(resetSelectedOrgsState))
        //
        //     if(resetSelectedOrgsState && Array.isArray(resetSelectedOrgsState)) {
        //         // 실패한 것만 목록에 추가
        //         setSelectedOrgsState(resetSelectedOrgsState.filter(org =>
        //             filedRcveRslt[org.insttCd] === true
        //         ));
        //     }
        //
        //     alert(JSON.stringify(selectedOrgsState))
        //     alert(JSON.stringify(resetSelectedOrgsState))
        //     // selectedOrgsState = {"key":"selectedOrgsState"}
        //     // resetSelectedOrgsState(실제 SelectedOrgsState 는 [["신한은행", null]]
        //
        // }

    }

    const makeDetailResultData = () => {
        if (typeof detailResultData === "undefined") return

        if (certType === 0 || certType === 1 || certType === 9999) { // 공동, 사설 인증
            initSelectedTarget(); // 공동, 사설 인증만 여럿 선택가능하므로 여기만 적용.

            const newList = []
            let scount = 0, fcount = 0, acount = 0
            detailResultData.forEach(org => {
                let found = newList.find(row => row.indstCd === org.indstCd)
                if (!found) {
                    found = {
                        indstCd: org.indstCd,
                        count: 0,
                        data: []
                    }
                    newList.push(found)
                }

                if (Lib.isNull(org.targetInfoList)) {
                    const assetList = Lib.deepCopy(org);

                    assetList.targetInfoListNull = true;
                    assetList.targetInfoList = [{ assetList: [org] }]
                    org = assetList;
                }

                found.data.push(org)
                org.targetInfoList.forEach(item => {
                    item.assetList.forEach(item => {
                        if (item.sucesYn === "Y") {
                            scount++
                        } else if (item.sucesYn === "N") {
                            fcount++
                        }
                        acount++
                    })
                })
            })

            console.log(detailResultData)
            console.log(newList) // [ {indstCd: "bank", count:0, data:[ {insttCd:"A1AAEQ0000", insttNm:"중소기업은행, targetInfoList:[{...
            setData(newList)
            setCount(acount)
            console.log(scount, fcount)
            setSuccessCount(scount)
            setFailCount(fcount)
        } else if (certType === 2) { // 개별인증
            console.log({ detailResultData })
            const asset = detailResultData[0]
            if (asset.sucesYn === "Y") {
                setSuccessCount(1)
            } else {
                setFailCount(1)
            }
            setCount(1)
            setData([
                {
                    indstCd: asset.indstCd,
                    count: 1,
                    data: [{
                        insttNm: asset.insttNm,
                        insttCd: asset.insttCd,
                        targetInfoList: [
                            {
                                asset_list: [
                                    {
                                        assetNm: asset.infNm,
                                        assetTpNm: asset.infTpNm,
                                        asset: asset.infId,
                                        sucesYn: asset.sucesYn,
                                        seqno: ""
                                    }
                                ]
                            }
                        ]
                    }]
                }
            ])
        }
    }


    useEffect(makeDetailResultData, [detailResultData])

    const getIndividualResultData = () => {
        Lib.get(`/api/data/v2/lnkup/rslt/${reqCd}`, data => {
            setDetailResultData(data);
        })
    }

    useEffect(() => {
        if (reqCd && !App.test) getIndividualResultData()
    }, [reqCd])

    useEffect(() => {
        App.setHeader({
            show: true,
            title: <></>,
            left: "",
            right: undefined
        })

        App.setShowNav(false)
        App.setMainClass("white")

        return () => {
            resetReqCd()
            resetShowDetailLayer()
            resetShowListLayer()
            resetTransmitRequest()
            if (!isRetry.current) {
                resetCertType()
                resetCertFrom()
            }
        }
    }, [])

    return (
        <div className="page">
            <div className="flex_1 padding">
                {
                    certFrom === "extend" &&
                    <div className={styles["count-group"]}>
                        <p>전송요구 종료시점이 연장되었습니다.</p>
                    </div>
                    ||
                    certFrom === "modify" &&
                    <div className={styles["count-group"]}>
                        <p>전송요구 종료시점이 변경되었습니다.</p>
                    </div>
                    ||
                    <div className={styles["count-group"]}>
                        <p>연결 결과</p>
                        <div><span>4</span>/4</div>
                    </div>
                }
                <div className="mt_20">
                    <div className="">
                        {
                            data ?
                                (
                                    data.length > 0 ?
                                        (data.map((industry, index) => {
                                            return (
                                                <div key={index}>
                                                    <div style={{ fontSize: "1.6rem", fontWeight: 500 }}
                                                        className={index > 0 ? "mt_30" : undefined}>{industries && (() => {
                                                            const found = industries.find(item => item.commCd.toLowerCase() === industry.indstCd)
                                                            if (found) {
                                                                if(found.commCd.toLowerCase() === "kinfa") {
                                                                    return "공공기관"
                                                                }else{
                                                                return found.commNm}
                                                            }
                                                        })()}</div>
                                                    {
                                                        industry.data.map((org, index) => {
                                                            return (
                                                                <div key={index}
                                                                    className={`block ${index > 0 ? "mt_20" : "mt_10"}`}>
                                                                    {
                                                                        org.targetInfoList.map((target, index) => {
                                                                            return (
                                                                                <div key={index}>
                                                                                    <div
                                                                                        className="flex-align_center"
                                                                                        style={org.targetInfoListNull ? {
                                                                                            width: "100%",
                                                                                        } : {}}>
                                                                                        <div
                                                                                            className="img-box img-symbol">
                                                                                            <Logo code={org.insttCd}
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%"
                                                                                                }} />
                                                                                        </div>
                                                                                        <div className={org.targetInfoListNull ? 'ml_10 flex-align_center justify_between' : 'ml_10'}
                                                                                            style={org.targetInfoListNull ? {
                                                                                                width: "100%",
                                                                                            } : {}}>
                                                                                            <p>{org.insttNm}</p>
                                                                                            {org.targetInfoListNull &&
                                                                                                org.sucesYn === "Y" &&

                                                                                                <span
                                                                                                    className="text-blue nowrap">성공</span>

                                                                                                ||
                                                                                                org.sucesYn === "N" &&
                                                                                                <span
                                                                                                    className="text-red nowrap">실패</span>
                                                                                            }
                                                                                        </div>
                                                                                    </div>

                                                                                    <ul className="mt_5"
                                                                                        style={{ lineHeight: 2 }}>
                                                                                        {
                                                                                            target.assetList.map((asset, index) => {
                                                                                                return (
                                                                                                    <li key={index}
                                                                                                        className="flex-justify_between">
                                                                                                        <span
                                                                                                            className="ellipsis mr_10">
                                                                                                            {
                                                                                                                asset.assetTpNm &&
                                                                                                                asset.asset !== '' &&
                                                                                                                <>
                                                                                                                    <i className={`tag mr_10 ${(() => {
                                                                                                                        switch (asset.assetTpNm) {
                                                                                                                            case "자유입출식":
                                                                                                                                return "tag-purple"
                                                                                                                            case "신용":
                                                                                                                                return "tag-sky"
                                                                                                                            case "휴대폰":
                                                                                                                                return "tag-pink"
                                                                                                                            default:
                                                                                                                                return "tag-blue"
                                                                                                                        }
                                                                                                                    })()
                                                                                                                        }`}>{asset.assetTpNm}</i>
                                                                                                                    {asset.assetNm}
                                                                                                                </>
                                                                                                            }
                                                                                                        </span>
                                                                                                        {
                                                                                                            asset.assetTpNm &&
                                                                                                            asset.asset !== '' &&
                                                                                                            <span>
                                                                                                                {
                                                                                                                    asset.assetTpNm &&
                                                                                                                    asset.asset !== '' &&
                                                                                                                    asset.sucesYn === "Y" &&
                                                                                                                    <span
                                                                                                                        className="text-blue nowrap">성공</span>
                                                                                                                    ||
                                                                                                                    asset.sucesYn === "N" &&
                                                                                                                    <span
                                                                                                                        className="text-red nowrap">실패</span>
                                                                                                                }
                                                                                                            </span>}
                                                                                                    </li>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </ul>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        })
                                        )
                                        :
                                        <NoData />
                                )
                                :
                                <div className="skeleton" />
                        }
                    </div>
                </div>
            </div>
            <div className="flex-shrink_0 padding btn-group flex-full">
                {
                    (successCount > 0 && failCount > 0) &&
                    <Button className="btn btn--big btn--gray" onClick={retry}>재시도</Button>
                }
                {
                    successCount === count &&
                    <Link to="/data"><Button className="btn btn--big btn--gray">추가연결</Button></Link>
                }
                {
                    failCount === count &&
                    <Link to="/"><Button className="btn btn--big btn--gray">다음에</Button></Link>
                }
                {
                    successCount > 0 &&
                    <Button className="btn btn--big ml_10" onClick={() => { setCertFromUrl("/mydata"); navigate(certFromUrl); }}>확인하러 가기</Button>
                }
                {
                    failCount === count &&
                    <Button className="btn btn--big ml_10" onClick={retry}>재시도</Button>
                }
            </div>
        </div>
    )
}

export default DataResult